export const getParts = async ({ urlParams }) => {
  let partsEndpoint = '/parts.json?';
  partsEndpoint += urlParams.toString();

  const response = await fetch(partsEndpoint);

  const contentType = response.headers.get('content-type');

  if (!contentType || !contentType.includes('application/json')) {
    throw new TypeError("Oops, we haven't got JSON!");
  }

  const responseJson = await response.json();

  if (!response.ok) {
    throw new Error(`Error ${response.status}: ${responseJson.error}`);
  }

  return responseJson;
}